import React, { useContext } from "react";

import { Button } from "../../Button";

import GeneralPageContext from "../../../templates/GeneralPageContext";
import { generateClassString } from "../../../lib/helper/generateClassString";

import * as styles from "./phoneContactButton.module.less";

export function PhoneContactButton({ className }) {
    const { contactPerson } = useContext(GeneralPageContext);

    if (!contactPerson) {
        return null;
    }

    const { phone } = contactPerson;

    return (
        <Button
            type={"primary"}
            renderAs="link"
            icon={"phone"}
            iconPosition={"left"}
            to={`tel:${phone}`}
            className={generateClassString(styles.contactButton, className)}
        >
            {phone}
        </Button>
    );
}
